import { useEffect } from 'react'
import * as store from '@store'
import { useWireValue } from '@forminator/react-wire'
import { CHECK_STATUSES_PROCESSING, RT_EVENT_TYPE_UPDATE_CHECK_STATUS } from '@/constants'
import { fetchCheckById } from '@/actions'

const useRealtimeCheckStatus = () => {
    const notifications = useWireValue(store.notifications)
    const checks = useWireValue(store.checks)
    const remoteConfig = useWireValue(store.remoteConfig)
    
    useEffect(() => {
        
        if (!remoteConfig?.realtimeEnabled) return
        
        const updateCheck = async () => {
            
            const latestNotification = notifications
                .filter(
                    notification => notification.message.data.type === RT_EVENT_TYPE_UPDATE_CHECK_STATUS,
                )
                .sort((a, b) => new Date(b.message.data.data.createdAt) - new Date(a.message.data.data.createdAt))[0]
            
            if (!latestNotification) return
            
            const { status: latestStatus, checkId } = latestNotification.message.data.data
            
            if (
                !CHECK_STATUSES_PROCESSING.includes(latestStatus) 
                && !!checks?.rows?.find(it => it.id === checkId)
            ) {
                await fetchCheckById(checkId)
            }
            
        }
        
        updateCheck()
        
    }, [notifications])
    
}

export default useRealtimeCheckStatus
